<h2 mat-dialog-title>Select Filter</h2>
<mat-dialog-content style="height: 400px; padding: 24px">
    <!-- Documents -->
    <mat-expansion-panel [expanded]="filterExpanderState.IsDocumentsExpanded" (opened)="filterExpanderState.IsDocumentsExpanded = true" (closed)="filterExpanderState.IsDocumentsExpanded = false">
        <mat-expansion-panel-header>
            <mat-panel-title>Documents</mat-panel-title>
        </mat-expansion-panel-header>
        <div style="display: flex; flex-direction: column;">
            <mat-form-field>
                <mat-label>Doc Id</mat-label>
                <input matInput [(ngModel)]="filter.DocId">
            </mat-form-field>
            <mat-form-field>
                <mat-label>Control Number</mat-label>
                <input matInput [(ngModel)]="filter.ControlNumber">
            </mat-form-field>
            <div class="row">
                <mat-form-field>
                    <mat-label>Bates Prefix</mat-label>
                    <input matInput [(ngModel)]="filter.BatesPrefix">
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Bates Start Number</mat-label>
                    <input matInput [(ngModel)]="filter.BatesNumberStart">
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Bates End Number</mat-label>
                    <input matInput [(ngModel)]="filter.BatesNumberEnd">
                </mat-form-field>
            </div>
            <mat-form-field>
                <mat-label>Title</mat-label>
                <input matInput [(ngModel)]="filter.Title">
            </mat-form-field>
            <mat-form-field>
                <mat-label>Extension</mat-label>
                <input matInput [(ngModel)]="filter.DocExtension">
            </mat-form-field>
            <mat-form-field>
                <mat-label>Source File Path</mat-label>
                <input matInput [(ngModel)]="filter.SourceFilePath">
            </mat-form-field>
            <div class="row">
                <mat-form-field>
                    <mat-label>Doc Start Date</mat-label>
                    <input matInput [matDatepicker]="docStart" [(ngModel)]="afterDate">
                    <mat-datepicker-toggle matSuffix [for]="docStart"></mat-datepicker-toggle>
                    <mat-datepicker #docStart></mat-datepicker>
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Doc End Date</mat-label>
                    <input matInput [matDatepicker]="docEnd" [(ngModel)]="beforeDate">
                    <mat-datepicker-toggle matSuffix [for]="docEnd"></mat-datepicker-toggle>
                    <mat-datepicker #docEnd></mat-datepicker>
                </mat-form-field>
                <mat-checkbox style="align-self: center;" [(ngModel)]="filter.DocDateNot">Not</mat-checkbox>
            </div>
            <div class="row">
                <mat-form-field>
                    <mat-label>Master Start Date</mat-label>
                    <input matInput [matDatepicker]="masterStart" [(ngModel)]="masterDateAfterDate">
                    <mat-datepicker-toggle matSuffix [for]="masterStart"></mat-datepicker-toggle>
                    <mat-datepicker #masterStart></mat-datepicker>
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Master End Date</mat-label>
                    <input matInput [matDatepicker]="masterEnd" [(ngModel)]="masterDateBeforeDate">
                    <mat-datepicker-toggle matSuffix [for]="masterEnd"></mat-datepicker-toggle>
                    <mat-datepicker #masterEnd></mat-datepicker>
                </mat-form-field>
                <mat-checkbox style="align-self: center;" [(ngModel)]="filter.MasterDateNot">Not</mat-checkbox>
            </div>
            <div class="row">
                <mat-form-field>
                    <mat-label>Upload Start Date</mat-label>
                    <input matInput [matDatepicker]="uploadStart" [(ngModel)]="uploadedAfterDate">
                    <mat-datepicker-toggle matSuffix [for]="uploadStart"></mat-datepicker-toggle>
                    <mat-datepicker #uploadStart></mat-datepicker>
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Upload End Date</mat-label>
                    <input matInput [matDatepicker]="uploadEnd" [(ngModel)]="uploadedBeforeDate">
                    <mat-datepicker-toggle matSuffix [for]="uploadEnd"></mat-datepicker-toggle>
                    <mat-datepicker #uploadEnd></mat-datepicker>
                </mat-form-field>
                <mat-checkbox style="align-self: center;" [(ngModel)]="filter.UploadDateNot">Not</mat-checkbox>
            </div>
            <mat-form-field>
                <mat-label>Custodian</mat-label>
                <mat-spinner *ngIf="!custodians" matSuffix [diameter]="18"></mat-spinner>
                <mat-select [(ngModel)]="filter.Custodian">
                    <mat-option></mat-option>
                    <mat-option *ngFor="let custodian of custodians" [value]="custodian.custodianId">{{custodian.name}}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field>
                <mat-label>Uploaded By</mat-label>
                <mat-spinner *ngIf="!uploaders" matSuffix [diameter]="18"></mat-spinner>
                <mat-select [(ngModel)]="filter.UploadUserId">
                    <mat-option></mat-option>
                    <mat-option *ngFor="let user of uploaders" [value]="user.id">{{user.userName}}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field>
                <mat-label>Upload Batch</mat-label>
                <mat-spinner *ngIf="!uploadBatches" matSuffix [diameter]="18"></mat-spinner>
                <mat-select [(ngModel)]="filter.UploadBatchId">
                    <mat-option></mat-option>
                    <mat-option *ngFor="let batch of uploadBatches" [value]="batch.id">{{batch.title}}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field>
                <mat-label>Briefcase Job</mat-label>
                <mat-spinner *ngIf="!briefcases" matSuffix [diameter]="18"></mat-spinner>
                <mat-select [(ngModel)]="filter.BriefcaseJobId">
                    <mat-option></mat-option>
                    <mat-option *ngFor="let briefcase of briefcases" [value]="briefcase.briefcaseJobId">{{briefcase.title}}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field>
                <mat-label>Review Set</mat-label>
                <mat-spinner *ngIf="!reviewSets" matSuffix [diameter]="18"></mat-spinner>
                <mat-select [(ngModel)]="filter.ReviewSetId">
                    <mat-option></mat-option>
                    <mat-option *ngFor="let set of reviewSets" [value]="set.reviewSetId">{{set.title}}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-checkbox [(ngModel)]="filter.ShowCurrentReviewBatch">Show Current Review Batch</mat-checkbox>
            <mat-checkbox [(ngModel)]="filter.ExcludeAttachments">Exclude Attachments</mat-checkbox>
            <mat-checkbox [(ngModel)]="filter.TranslationStatus">Show Translated Only</mat-checkbox>
            <mat-checkbox [(ngModel)]="filter.RedactionStatus">Show Redacted Only</mat-checkbox>
            <mat-checkbox [(ngModel)]="filter.AnnotationStatus">Show Annotated Only</mat-checkbox>
            <mat-form-field>
                <mat-label>Document Has Notes</mat-label>
                <mat-select [(ngModel)]="filter.HasNotes">
                    <mat-option></mat-option>
                    <mat-option value="1">Checked</mat-option>
                    <mat-option value="2">Unchecked</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field>
                <mat-label>Duplicates</mat-label>
                <mat-select [(ngModel)]="filter.Duplicates">
                    <mat-option></mat-option>
                    <mat-option value="1">Exclude Duplicates</mat-option>
                    <mat-option value="2">Show Duplicates Only</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-checkbox (change)="placeholderUnsupported($event)" [checked]="isUnsupported">Placeholder (Unsupported)</mat-checkbox>
            <mat-checkbox (change)="placeholderFailedToConvert($event)" [checked]="isFailedToConvert">Placeholder (Failed to Convert)</mat-checkbox>
            <mat-form-field>
                <mat-label>Production Job</mat-label>
                <mat-spinner *ngIf="!productionJobs" matSuffix [diameter]="18"></mat-spinner>
                <mat-select [(ngModel)]="filter.ProductionJobId">
                    <mat-option></mat-option>
                    <mat-option *ngFor="let job of productionJobs" [value]="job.productionJobId">{{job.title}}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field>
                <mat-label>Near Dup Group Id</mat-label>
                <input matInput [(ngModel)]="filter.TextGroupId">
            </mat-form-field>
            <mat-form-field>
                <mat-label>Email Thread Id</mat-label>
                <input matInput [(ngModel)]="filter.EmailThreadId">
            </mat-form-field>
            <mat-checkbox [(ngModel)]="filter.ExcludeRedundantEmails">Exclude Redundant Emails</mat-checkbox>
            <mat-form-field>
                <mat-label>Original Title</mat-label>
                <input matInput [(ngModel)]="filter.OriginalTitle">
            </mat-form-field>
            <mat-form-field>
                <mat-label>Description</mat-label>
                <input matInput [(ngModel)]="filter.Description">
            </mat-form-field>
        </div>
    </mat-expansion-panel>

    <!-- Discovery -->
    <mat-expansion-panel [expanded]="filterExpanderState.IsDiscoveryExpanded" (opened)="filterExpanderState.IsDiscoveryExpanded = true" (closed)="filterExpanderState.IsDiscoveryExpanded = false">
        <mat-expansion-panel-header>
            <mat-panel-title>Discovery</mat-panel-title>
        </mat-expansion-panel-header>
        <div style="display: flex; flex-direction: column;">
          <div class="row">
            <mat-form-field>
              <mat-label>Responsive</mat-label>
              <mat-select [(ngModel)]="filter.Responsive">
                <mat-option></mat-option>
                <mat-option value="docCodingResponsiveness.NotSpecified">Not Specified</mat-option>
                <mat-option value="docCodingResponsiveness.Responsive">Responsive</mat-option>
                <mat-option value="docCodingResponsiveness.NonResponsive">Non-Responsive</mat-option>
                <mat-option value="docCodingResponsiveness.NeedsFurtherReview">Needs Further Review</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-checkbox style="align-self: center;" [(ngModel)]="filter.ResponsiveFilterNot">Not</mat-checkbox>
          </div>
          <mat-form-field>
            <mat-label>Privileged/Work Product</mat-label>
            <mat-select [(ngModel)]="filter.Privilege">
              <mat-option></mat-option>
              <mat-option value="1">Privilege</mat-option>
              <mat-option value="2">Work Product</mat-option>
              <mat-option value="3">Privilege or Work Product</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field>
            <mat-label>Confidential</mat-label>
            <mat-select [(ngModel)]="filter.Confidential">
              <mat-option></mat-option>
              <mat-option value="1">Checked</mat-option>
              <mat-option value="2">Unchecked</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field>
            <mat-label>Custom Designation</mat-label>
            <mat-select [(ngModel)]="filter.CustomDesignation">
              <mat-option></mat-option>
              <mat-option value="1">Checked</mat-option>
              <mat-option value="2">Unchecked</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field>
            <mat-label>Key Document</mat-label>
            <mat-select [(ngModel)]="filter.IsKey">
              <mat-option></mat-option>
              <mat-option value="1">Checked</mat-option>
              <mat-option value="2">Unchecked</mat-option>
            </mat-select>
          </mat-form-field>
          <div>
            <div style="display: flex; justify-content: space-between;">
              <div style="display: flex;">
                <div>Reviewed by</div>
                <mat-spinner *ngIf="!reviewers" [diameter]="18" style="margin-left: 5px;"></mat-spinner>
              </div>
              <mat-checkbox [(ngModel)]="filter.ReviewersFilterNot">Not</mat-checkbox>
            </div>
            <mat-selection-list class="list" [(ngModel)]="reviewedBy">
              <mat-list-option *ngFor="let reviewer of reviewers" [value]="reviewer.id">{{reviewer.userName}}</mat-list-option>
            </mat-selection-list>
          </div>
        </div>
    </mat-expansion-panel>

    <!-- General Coding -->
    <mat-expansion-panel [expanded]="filterExpanderState.IsGeneralCodingExpanded" (opened)="filterExpanderState.IsGeneralCodingExpanded = true" (closed)="filterExpanderState.IsGeneralCodingExpanded = false">
        <mat-expansion-panel-header>
            <mat-panel-title>General Coding</mat-panel-title>
        </mat-expansion-panel-header>
        <div style="display: flex; flex-direction: column;">
            <div>
                <div style="display: flex;">
                    <div>Doc Source</div>
                    <mat-spinner *ngIf="!docSources" [diameter]="18" style="margin-left: 5px;"></mat-spinner>
                </div>
                <mat-selection-list class="list" [(ngModel)]="docSource">
                    <mat-list-option *ngFor="let src of docSources" [value]="src">{{src}}</mat-list-option>
                </mat-selection-list>
            </div>
            <mat-form-field>
                <mat-label>From</mat-label>
                <input matInput [(ngModel)]="filter.FromField">
            </mat-form-field>
            <mat-form-field>
                <mat-label>To</mat-label>
                <input matInput [(ngModel)]="filter.ToField">
            </mat-form-field>
            <mat-form-field>
                <mat-label>Cc</mat-label>
                <input matInput [(ngModel)]="filter.CcField">
            </mat-form-field>
            <mat-form-field>
                <mat-label>Bcc</mat-label>
                <input matInput [(ngModel)]="filter.BccField">
            </mat-form-field>
            <mat-form-field>
                <mat-label>Subject</mat-label>
                <input matInput [(ngModel)]="filter.SubjectMatter">
            </mat-form-field>
            <mat-form-field>
                <mat-label>Author</mat-label>
                <input matInput [(ngModel)]="filter.Author">
            </mat-form-field>
            <mat-form-field>
                <mat-label>Last Modified By</mat-label>
                <input matInput [(ngModel)]="filter.LastModifiedBy">
            </mat-form-field>
            <div>
                <div style="display: flex;">
                    <div>Doc Type</div>
                    <mat-spinner *ngIf="!docTypes" [diameter]="18" style="margin-left: 5px;"></mat-spinner>
                </div>
                <mat-selection-list class="list" [(ngModel)]="docType">
                    <mat-list-option *ngFor="let type of docTypes" [value]="type">{{type}}</mat-list-option>
                </mat-selection-list>
            </div>
        </div>
    </mat-expansion-panel>

    <!-- Dynamic Coding -->
    <mat-expansion-panel [expanded]="filterExpanderState.IsDynamicCodingExpanded" (opened)="filterExpanderState.IsDynamicCodingExpanded = true" (closed)="filterExpanderState.IsDynamicCodingExpanded = false">
        <mat-expansion-panel-header>
            <mat-panel-title>Dynamic Coding</mat-panel-title>
        </mat-expansion-panel-header>
        <mat-list *ngFor="let parent of ccfManager.getParents()">
            <div style="display: flex; justify-content: space-between; background-color: #eeee; border-radius: 4px; height: 30px;">
                <div style="align-self: center; margin-left: 10px;">{{parent.displayTitle}}</div>
                <mat-checkbox [(ngModel)]="dynamicCodingFilterNot[parent.fieldId]" style="align-self: center; margin-right: 10px;">Not</mat-checkbox>
            </div>
            <div style="display: flex; flex-direction: column;  margin: 10px;">
                <ng-container *ngFor="let child of ccfManager.getChildren(parent.fieldId)">
                    <mat-form-field *ngIf="child.type === 1">
                      <mat-label>{{child.displayTitle}}</mat-label>
                        <input matInput [(ngModel)]="dynamicCodingFilterTextbox[child.fieldId]">
                    </mat-form-field>
                    <mat-checkbox *ngIf="child.type === 2" [(ngModel)]="dynamicCodingFilterCheckbox[child.fieldId]">{{child.displayTitle}}</mat-checkbox>
                    <mat-checkbox *ngIf="child.type === 3" [(ngModel)]="dynamicCodingFilterSharedCheckbox[child.fieldId]">{{child.displayTitle}}</mat-checkbox>
                </ng-container>
            </div>
        </mat-list>
    </mat-expansion-panel>
</mat-dialog-content>

<mat-dialog-actions style="place-content: stretch flex-end; align-items: stretch; flex-direction: row; box-sizing: border-box; display: flex;">
    <button mat-raised-button color="primary" (click)="ok()">OK</button>
    <button mat-raised-button color="secondary" (click)="cancel()">Cancel</button>
</mat-dialog-actions>
